

import fragmentShader from './shader.frag'
// import fragmentShader_sp from './shader_sp.frag'
// import fragmentShader2 from './shader4.frag'
// import fragmentShader3 from './shader5.frag'
import Background from './Background.js'
import nnDSPObject from './dspobject'

// const ua = navigator.userAgent
// const is_ios = ua.indexOf("iPhone") >= 0 || ua.indexOf("iPad") >= 0 || navigator.userAgent.indexOf("iPod") >= 0

class ScrollFilter{
  constructor(){
    this.scrollTop = 0;
    this.watch();
    this.setupFilters();
    this.filter = new nnDSPObject.LP2HP({
      lpf: .03,
      hpf: 0.001,
    });
  }
  gui(){
    this.tmp = {
      lpf: .03,
      hpf: 0.05,
    }
    var controller = gui.add(this.tmp, 'lpf', 0, 0.5);
    controller.onChange((value) => {
      this.tmp.lpf = value;
      this.filter.setCutoff(this.tmp.lpf, this.tmp.hpf)
    });
    var controller = gui.add(this.tmp, 'hpf', 0, 0.4);
    controller.onChange((value) => {
      this.tmp.hpf = value;
      this.filter.setCutoff(this.tmp.hpf, this.tmp.hpf)
    });

  }
  setupFilters(){

  }
  watch(){
    // window.addEventListener('scroll', this.onScroll.bind(this));
  }
  onScroll(e){
    // console.log(window.pageYOffset)
    this.scrollTop = window.pageYOffset;
  }
  process(){
    this.onScroll()
    const filtered = this.filter.filter(this.scrollTop);
    const sign = filtered <= 0 ? -1 : 1;
    return filtered * 0.001;
  }
}

$(() => {

  //dev
  // const shaders = [
  //   fragmentShader,
  //   fragmentShader2,
  //   fragmentShader3
  // ]
  // const shader = location.search ? shaders[~~location.search.split('?')[1]] : shaders[0]

  // const shader = is_ios || window.matchMedia("(max-width: 750px)").matches ? fragmentShader_sp : fragmentShader
  // const shader = 
  const scrollFilter = new ScrollFilter()
  const bg = new Background({
    id: 'canvas',
    shader: fragmentShader
    // shader: shader
  })
  bg.clear(1);

  var frameCount = 0;
  ; (function loop() {
    if (frameCount % 2 === 0) {
      bg.draw(frameCount)
      const filterdScroll = scrollFilter.process()
      bg.setScroll(filterdScroll)
      // bg.mouse(filterdMouse)
    }
    frameCount++
    requestAnimationFrame(loop)
  })()
  bg.draw(23)
})